import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React from 'react';

interface IExtraPaymentTypeIdField {
	fieldId: string;
	changePaymentTypeId: (value: string) => void;
	validationRules: Rule[];
}

const ExtraPaymentTypeIdField: React.FC<IExtraPaymentTypeIdField> = ({
	fieldId,
	changePaymentTypeId,
	validationRules,
}) => {
	return (
		<FormInput
			testId="ExtraPaymentTypeIdField"
			name={`extraPaymentTypeId-${fieldId}`}
			label="paymentTypeIdLabel"
			onChange={changePaymentTypeId}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ExtraPaymentTypeIdField);
